import {
	LayersControlGroup,
	LayersControlGroupContent,
	LayersControlGroupHeader,
	LayersControlGroupItem,
} from '../../components';
import LayerSwitcher from '../../../../../common/controls/LayerSwitcher';
import PropTypes from 'prop-types';

const VectorLayerControl = ({
	mapKey,
	configuration,
	activeDivision,
	layer,
	title,
}) => {
	const layerKey = configuration?.[activeDivision]?.layerKeys?.[layer];
	if (layerKey) {
		return (
			<LayersControlGroup>
				<LayersControlGroupHeader>{title}</LayersControlGroupHeader>
				<LayersControlGroupContent>
					<LayersControlGroupItem>
						<LayerSwitcher mapKey={mapKey} layerKey={layerKey} />
					</LayersControlGroupItem>
				</LayersControlGroupContent>
			</LayersControlGroup>
		);
	} else {
		return null;
	}
};

VectorLayerControl.propTypes = {
	mapKey: PropTypes.string,
	configuration: PropTypes.object,
	activeDivision: PropTypes.string,
	layer: PropTypes.string,
	title: PropTypes.string,
};

const VectorLayersControls = ({mapKey, configuration, activeDivision}) => {
	return (
		<>
			<VectorLayerControl
				title="Land use blocks (Apia)"
				mapKey={mapKey}
				configuration={configuration}
				activeDivision={activeDivision}
				layer="zones"
			/>
			<VectorLayerControl
				title="Coastal sectors"
				mapKey={mapKey}
				configuration={configuration}
				activeDivision={activeDivision}
				layer="zonesCoastal"
			/>
			<VectorLayerControl
				title="Stream sectors"
				mapKey={mapKey}
				configuration={configuration}
				activeDivision={activeDivision}
				layer="zonesRiparian"
			/>
		</>
	);
};

VectorLayersControls.propTypes = {
	mapKey: PropTypes.string,
	configuration: PropTypes.object,
	activeDivision: PropTypes.string,
};

export default VectorLayersControls;
